<template>
  
  <list-expansion
    v-if="obj"
    v-model="obj"
    :components="customComponents"
    :disabled="loading"
    :service-name="serviceName"
    :component-name="componentName"
  @save-required="$emit('save-required')"

  />
</template>

<script>
import ListExpansion from "../../../../content/fragments/listExpansion";

export default {
  name: "qrManagement",

  components: { ListExpansion },

  props: {
    value: Object,
    qrId: [Number, String],
    qrDomain: String,
    serviceName: { type: String, default: "Qrland" },
    componentName: { type: String, default: "" },
  },

  data() {
    return {
      obj: null,
      loading: false,
      // customComponents: [
      //   {
      //     name: "managePasswordQr",
      //     value: "",
      //     title: this.$t("manage_password"),
      //     subtitle: "",
      //     icon: "lock-outline",
      //     model: "password",
      //   },
      //   {
      //     name: "manageHourLimitQr",
      //     value: "",
      //     title: this.$t("hour_limit"),
      //     subtitle: "",
      //     icon: "timer-plus-outline",
      //     model: "dateLimit",
      //   },
      //   {
      //     name: "manageClickLimitQr",
      //     value: "",
      //     title: this.$t("scan_click_limit"),
      //     subtitle: "",
      //     icon: "cursor-default-click-outline",
      //     model: "max_click",
      //   },
      //   {
      //     name: "manageRedirectQr",
      //     value: "",
      //     title: this.$t("redirect_scanner"),
      //     subtitle: "",
      //     icon: "line-scan",
      //     model: "urls",
      //   },
      // ],
    };
  },
  computed: {
    customComponents() {
      return [
        {
          name: "managePasswordQr",
          value: "",
          title: this.$t("manage_password"),
          subtitle: "",
          icon: "lock-outline",
          model: "password",
        },
        {
          name: "manageHourLimitQr",
          value: "",
          title: this.$t("hour_limit"),
          subtitle: "",
          icon: "timer-plus-outline",
          model: "dateLimit",
        },
        {
          name: "manageClickLimitQr",
          value: "",
          title: this.$t("scan_click_limit"),
          subtitle: "",
          icon: "cursor-default-click-outline",
          model: "max_click",
        },
        {
          name: "manageRedirectQr",
          value: "",
          title: this.$t("redirect_scanner"),
          subtitle: "",
          icon: "line-scan",
          model: "urls",
        },
      ];
    },
  },
  watch: {
    value(val, oldVal) {
      this.fetch(val);
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    update() {
      this.loading = true;
      this.obj.identifier = this.qrId;

      return new Promise((resolve, reject) => {
        let obj = {};
        if (this.$route.fullPath.includes("qr/setting2")) {
          obj = {
            type: this.value?.type,
            qr_id: (this.qrDomain ?? this.value?.domain?.name).replace(
              /\/*$/g,
              "/",
            ),
            identifier:
              this.qrId ?? this.value?.identifier ?? this.obj?.identifier ?? "",
          };
        } else {
          obj = {
            domain: (this.qrDomain ?? this.value?.domain?.name).replace(
              /\/*$/g,
              "/",
            ),

            identifier:
              this.qrId ?? this.value?.identifier ?? this.obj?.identifier ?? "",
          };
        }

        if (this.obj.password) {
          obj.password = this.obj.password;
        }
        if (this.obj.dateLimit.activated_at) {
          obj.activated_at = this.obj.dateLimit.activated_at;
        }
        if (this.obj.dateLimit.deactivated_at) {
          obj.deactivated_at = this.obj.dateLimit.deactivated_at;
        }
        obj.activated_at = this.obj.dateLimit?.activated_at || null;
        obj.deactivated_at = this.obj.dateLimit?.deactivated_at || null;
        obj.max_click = this.obj.max_click || null;

        if (this.obj.urls) {
          obj.windows_url = this.obj.urls.windows_url || null;
          obj.android_url = this.obj.urls.android_url || null;
          obj.ios_url = this.obj.urls.ios_url || null;
        }
        // if (this.obj.urls.windows_url) {
        //   obj.windows_url = this.obj.urls.windows_url;
        // }
        // if (this.obj.urls.android_url) {
        //   obj.android_url = this.obj.urls.android_url;
        // }
        // if (this.obj.urls.ios_url) {
        //   obj.ios_url = this.obj.urls.ios_url;
        // }
        // if (this.obj.max_click) {
        //   obj.max_click = this.obj.max_click;
        // }

        this.$api
          .put("/v1/testQr/update", obj)
          .then(({ data }) => resolve("resolved"))
          .catch(({ response }) => {
            this.loading = false;
            this.$toast.error(this.$t("edit_settings_error"));
            reject();
          })
          .finally(() => (this.loading = false));
      });
    },
    fetch(value) {
      this.obj = {
        identifier: value?.identifier || null,
        password: value?.password || null,
        dateLimit: {
          activated_at: value?.activated_at || null,
          deactivated_at: value?.deactivated_at || null,
        },
        urls: {
          windows_url: value?.windows_url || null,
          android_url: value?.android_url || null,
          ios_url: value?.ios_url || null,
        },
        // trackVisits: 1,
        max_click: value?.max_click,
      };
    },
  },
};
</script>

<style scoped></style>
